module.exports = __webpack_public_path__ + "img/f39.eceaf220.jpg";